module.exports = __webpack_public_path__ + "img/close-img.14cedd17.svg";